import useTranslation from "next-translate/useTranslation";
import LogoImage from "./logo_image";
import Rating from "./rating";

const UserImage = (props) => {
  const { t } = useTranslation("common");

  return (
    <div
      className="avatar-container d-flex justify-content-center text-center rounded-circle p-0"
      style={{
        width: props.width,
        height: props.height,
        boxShadow: props.borderColor ? `0 0 0 3px ${props.borderColor}` : null,
        padding: props.borderColor ? "2px" : null,
      }}
    >
      <LogoImage {...props} src={props.src && props.src != "null" && props.src != "undefined" ? props.src : null} />

      <small className="badge badge-mini avatar-raiting">
        <Rating rating={props.rating} />
      </small>
    </div>
  );
};

export default UserImage;
